'use strict';

namespace Config {

    /**
     * ウィンドウサイズ:サイズ幅
     */
    export const MQ_TB:number = 768;
    export const MQ_SP: number = 768;
    
    /**
     * ウィンドウサイズ:名称
     */
    export const MODE_PC:string = 'PC';
    export const MODE_TB:string = 'TB';
    export const MODE_SP: string = 'SP';

	export const EVENT_LOADED: string = 'EVENT_LOADED';//全ファイル読み込み完了
}

export default Config;